<template>
  <div
    v-if="attachments && attachments.length"
    class="asset-recommendation-component"
  >
    <carousel
      :item-width="351"
      :show-header="true"
      :tile-count="attachments.length"
      :tile-type="'block'"
    >
      <template v-slot:heading>
        You Might Also Like
      </template>
      <block-tile
        v-for="attachment in attachments"
        :key="attachment.id"
        :asset="attachment"
        :asset-type="`Attachment`"
        :content-source="contentSource(attachment)"
        :featured-image="featuredImage(attachment)"
        :metadata="metadata(attachment)"
        :metadata-icon-name="attachment.icon"
        :source="{ type: 'Recommended Attachment Page' }"
        :title="attachment.assetTitle"
        @tile-clicked="handleTileClick(attachment)"
      />
    </carousel>
  </div>
</template>

<script>
import Carousel from '@/components/carousels/carousel.vue';
import BlockTile from '@/components/ui/blockTile.vue';

export default {
  name: 'AssetRecommendations',
  components: {
    Carousel,
    BlockTile,
  },
  props: {
    attachmentIds: {
      type: Array,
    },
    pageAttachment: {
      type: Object,
    },
  },
  computed: {
    attachments() {
      return this.attachmentIds.map(id => this.$store.getters['attachments/get'][id]);
    },
  },
  methods: {
    contentSource(attachment) {
      if (attachment.contentSourceId) {
        return this.$store.getters['contentSources/get'][attachment.contentSourceId];
      }
    },
    featuredImage(attachment) {
      if (attachment.displayAttachmentId) {
        return this.$store.getters['attachments/get'][attachment.displayAttachmentId];
      }
    },
    handleTileClick(attachment) {
      const analyticsParams = {
        assetId: attachment.id,
        assetType: 'Attachment',
        assetTitle: attachment.assetTitle,
        referringAssetId: this.pageAttachment?.id,
        referringAssetTitle: this.pageAttachment?.assetTitle,
        referringAssetType: 'Attachment',
      };
      this.$analytics.events.viewedRecommendedItemFromAsset(analyticsParams);

      this.$router.push({
        name: 'library#show',
        params: {
          assetType: 'attachment',
          assetId: attachment.id,
        },
        query: this.currentQuery,
      });
    },
    metadata(asset) {
      return asset.cardMetadata(this.$store);
    },
  },
};
</script>

<style lang="scss" scoped>
.asset-recommendation-component {
  margin-top: rem-calc(32);
}
</style>
